module.exports = __webpack_public_path__ + "resources/img/img_secureguard1.b54383d5b2035da1fc8018381da1013c.png";